module.exports = __webpack_public_path__ + "img/swords-white.a1f71e71.svg";